import axios from 'axios';

/* 
French Government Geo API for city autocomplete
    API doc: https://geo.api.gouv.fr/decoupage-administratif/communes
    https://geo.api.gouv.fr/communes?nom=borde&fields=nom,code,codesPostaux,centre&boost=population&limit=10
    
Nominatim API for reverse geocoding
    api doc https://nominatim.org/release-docs/develop/api/Search/
*/

// French Geo API for city search (better autocomplete)
const GEO_API_BASE_URL = 'https://geo.api.gouv.fr/communes';
const FORMAT = 'jsonv2';
const LIMIT = 10;
const ADDRESS_DETAILS = 1;

export const searchCity = async (query, postalCode = null, limitNb = LIMIT) => {
    // Ensure query is a string and handle null/undefined cases
    const queryStr = String(query || '').trim();
    
    if (!queryStr) {
        console.warn('Empty search term provided');
        return [];
    }

    try {
        // Use French Geo API for better autocomplete support
        const params = {
            nom: queryStr,
            fields: 'nom,codesPostaux,centre',
            boost: 'population',
            limit: limitNb,
        };

        // If postal code provided, search by postal code instead
        if (postalCode) {
            params.codePostal = postalCode;
        }

        const response = await axios.get(GEO_API_BASE_URL, { params });

        const citySuggestions = response.data.map((item) => {
            const cityName = item.nom || '';
            const postal = item.codesPostaux?.[0] || '';
            const geo = item.centre ? `${item.centre.coordinates[1]},${item.centre.coordinates[0]}` : '';

            return { cityName, postalCode: postal, geo };
        });

        return citySuggestions;
    } catch (error) {
        console.error('Error fetching suggestions:', error);
        return [];
    }
};

export const reverseGeocode = async (lat, lon) => {
    try {
        const params = {
            lat,
            lon,
            format: FORMAT,
            addressdetails: ADDRESS_DETAILS,
            'accept-language': 'fr',
        };

        const response = await axios.get('https://nominatim.openstreetmap.org/reverse', { params });
        const address = response.data.address;
        
        if (address && address.country_code === 'fr') {
            const cityName = address.city || address.town || address.village || address.municipality || '';
            const postalCode = address.postcode || '';
            const geo = `${lat},${lon}`;
            
            if (cityName) {
                return { cityName, postalCode, geo };
            }
        }
        return null;
    } catch (error) {
        console.error('Error reverse geocoding:', error);
        return null;
    }
};